import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { UserService } from "./service/user.service";

@Injectable({
  providedIn: "root",
})
export class AuthLoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private userService: UserService,
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    if (this.userService.getToken()) {
      console.log("%cI am here", "color: red");
      this.router.navigate(["/home"]);
      return false;
    } else {
      return true;
    }
  }
}
